<template>
  <v-dialog id="loadingWdg" v-model="modalShow" persistent :max-width="290">
    <v-card color="primary" dark>
      <v-card-text>
        Por favor espere
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    modalShow: {
      type: Boolean,
      default: true
    }
  }
};
</script>
